const isAppPath = (pathname) =>
  pathname.startsWith('/secure') ||
  pathname.startsWith('/login') ||
  pathname.startsWith('/signup') ||
  pathname.startsWith('/reset-password') ||
  !pathname.startsWith('/');

export default isAppPath;
